import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=13196fde&scoped=true&"
import script from "./activity-list.vue?vue&type=script&lang=js&"
export * from "./activity-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=13196fde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13196fde",
  null
  
)

export default component.exports